import { atom } from 'jotai';
import { COMPARISON_ID, COMPARISON_TYPE, RADAR_DATA_FORMAT } from '@/consts/searchKeys';
import { ComparisonType } from '@/types/comparison';
import { atomWithQueryParam } from './location';

/* this is purposefully set to "unset" by default, so if the queryParams
do not contain a filter set id, it will be set to null but we keep it truthy
by default so the comp and season defaults don't come into play unless this
gets set to null via the corresponding hook  */
export const filterSetIdAtom = atom<string | null>('unset');

export const comparisonIdAtom = atomWithQueryParam(COMPARISON_ID, 'number');
export const comparisonTypeAtom = atomWithQueryParam(COMPARISON_TYPE);
export const radarDataFormatParamAtom = atomWithQueryParam(RADAR_DATA_FORMAT);

export const isCompetitionAverageModeAtom = atom(get => get(comparisonTypeAtom) === ComparisonType.CompetitionAverage);
